export default "__VITE_ASSET__BuSsoOhe__"